import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getSettings } from "@/lib/api";
import { TwitterLogo, LinkedinLogo, TelegramLogo, GithubLogo } from "@phosphor-icons/react";

const COLS = [
  {
    title: "Technology",
    links: [
      ["Technology", "/technology"],
      ["Q-Core Engine", "/q-core"],
      ["Strategies", "/strategies"],
      ["Security", "/security"],
      ["How It Works", "/how-it-works"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About", "/about"],
      ["Team", "/team"],
      ["Roadmap", "/roadmap"],
      ["Events", "/events"],
      ["FAQ", "/faq"],
    ],
  },
  {
    title: "Ecosystem",
    links: [
      ["Partners", "/partners"],
      ["Leadership", "/leadership"],
      ["License", "/pricing"],
      ["Contact", "/contact"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Compliance Center", "/compliance"],
      ["Terms", "/compliance"],
      ["Privacy", "/compliance"],
      ["Risk Disclosure", "/compliance"],
    ],
  },
];

export function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    getSettings().then(setSettings).catch(() => {});
  }, []);

  const disclaimer =
    settings?.disclaimer ||
    "Quantum Scalp provides software and technology services. Automated cryptocurrency trading involves substantial risk, including the possible loss of capital. No trading strategy or technology guarantees profits. Nothing on this website constitutes investment, financial, legal, or tax advice. Availability of products and services may vary by jurisdiction.";

  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#08090F]">
      <div className="absolute inset-0 qs-grid opacity-[0.15] pointer-events-none" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img src="/logo.png" alt="Quantum Scalp" className="h-10 w-auto" />
            </Link>
            <p className="text-sm text-[#94A3B8] max-w-xs leading-relaxed">
              {settings?.tagline || "AI-powered arbitrage technology through software licensing."}
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                [TwitterLogo, settings?.social?.twitter, "twitter"],
                [LinkedinLogo, settings?.social?.linkedin, "linkedin"],
                [TelegramLogo, settings?.social?.telegram, "telegram"],
                [GithubLogo, settings?.social?.github, "github"],
              ].map(([Icon, href, key]) => (
                <a
                  key={key}
                  href={href || "#"}
                  data-testid={`footer-social-${key}`}
                  className="grid place-items-center h-9 w-9 rounded-md border border-white/10 text-[#94A3B8] hover:text-[#2DD4BF] hover:border-[#2DD4BF]/40 transition-colors"
                  aria-label={key}
                >
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-white mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={label + to}>
                    <Link to={to} className="text-sm text-[#94A3B8] hover:text-[#2DD4BF] transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-lg border border-white/10 bg-white/[0.02] p-5">
          <p className="font-mono text-[11px] uppercase tracking-widest text-amber-300/80 mb-2">Legal Disclaimer</p>
          <p className="text-xs text-[#94A3B8] leading-relaxed">{disclaimer}</p>
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#64748B]">
          <p>© {new Date().getFullYear()} Quantum Scalp AI. All rights reserved.</p>
          <p className="font-mono">
            Software & technology services · Trading involves risk
          </p>
        </div>
      </div>
    </footer>
  );
}
